import PatientDoctorDocumentsTable from './PatientDoctorDocumentsTable';
import { useDataUser } from '../../context/dataUserContext';

const DoctorAssignedDocuments = () => {
    const { doctorId } = useDataUser();

    return (
        <div className="space-y-6">
            <PatientDoctorDocumentsTable
                doctorId={doctorId}
                isDownload={true}
            />
        </div>
    );
};

export default DoctorAssignedDocuments;
